var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParallelogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.211,
    height: 13,
    viewBox: "0 0 11.211 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M1587,1336l-5.181,13H1588l5.03-13Z",
    transform: "translate(-1581.815 -1336)",
    fill: "#61b2c1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParallelogram);
export default __webpack_public_path__ + "static/media/parallelogram.04ec813d5632dbffdd2dcca411823204.svg";
export { ForwardRef as ReactComponent };